module.exports = __webpack_public_path__ + "static/media/mars-logo.306bbff8.png";